import { createContext, PropsWithChildren, use, useMemo } from "react";
import { doc, FirestoreDataConverter } from "firebase/firestore";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { IProduct } from "~/integrations/firebase/collections";
import { db } from "~/integrations/firebase/firestore";

interface ProductContextType {
  product?: IProduct;
  loading?: boolean;
  error?: string;
}

export const ProductContext = createContext<ProductContextType>(
  undefined as never,
);

interface ProductProviderProps {
  id: string;
}

const productConverter: FirestoreDataConverter<IProduct> = {
  fromFirestore(snapshot) {
    const data = snapshot.data() as IProduct;
    return {
      ...data,
      id: snapshot.id,
      isbn: data.identifier,
    };
  },
  toFirestore: (data) => data,
};

export function ProductProvider({
  id,
  children,
}: PropsWithChildren<ProductProviderProps>) {
  const [product, loading, error] = useDocumentData(
    doc(db, "products", id).withConverter(productConverter),
  );

  const value = useMemo(
    () => ({
      product,
      loading,
      error: error?.message,
    }),
    [product, loading, error?.message],
  );

  return <ProductContext value={value}>{children}</ProductContext>;
}

export const useProduct = () => use(ProductContext);
